import React from "react";
import styled from "styled-components";
import paymentLogos from "../../util/paymentLogos";
import mastercard from "../../assets/images/payment-logos/mastercard.png";
import maestro from "../../assets/images/payment-logos/maestro.png";
import idcheck from "../../assets/images/payment-logos/idcheck.png";
import visa from "../../assets/images/payment-logos/visa.png";
import visasecure from "../../assets/images/payment-logos/visasecure.png";
import sberbank from "../../assets/images/payment-logos/sberbank.png";
import { Flex } from "reflexbox";

const PaymentLogos = () => {
    const openCreditCardSite = url => {
        window.open(url);
    };

    return (
        <>
            {paymentLogos.map(pl => {
                let img = null;
                switch (pl.img) {
                    case "MasterCard":
                        img = mastercard;
                        break;
                    case "MaestroCard":
                        img = maestro;
                        break;
                    case "IDCheck":
                        img = idcheck;
                        break;
                    case "Visa":
                        img = visa;
                        break;
                    case "VisaSecure":
                        img = visasecure;
                        break;
                    case "Sberbank":
                        img = sberbank;
                        break;
                    default:
                        img = null;
                }
                return (
                    <Wrapper>
                        <CreditCardImg key={pl.key} onClick={() => openCreditCardSite(pl.url)} src={img} />
                    </Wrapper>
                );
            })}
        </>
    );
};

const Wrapper = styled(Flex)`
    width: 62px;
    flex-grow: 1;
    justify-content: center;
`;

const CreditCardImg = styled.img`
    cursor: pointer;
    border-radius: 5px;
    height: ${({ height }) => (height ? height : "50px")};
    width: ${({ width }) => (width ? width : "72px")};
    background: #fff;
`;

export default PaymentLogos;
